function add_contact_refresher_course(vars) {
    var $ = jQuery.noConflict();

    $.squdeAjaxPopup({
        url: '/courseRefresher/add',
        onOpen: function (elm, popup) {
            var contact_selector = $('select#contact_id');
            if(vars != undefined && vars.contact_id) {
                contact_selector.attr('data-current-value', vars.contact_id);
            }
            contact_selector.contactSelector();
            $('select#course_id').courseSelector();

            elm.find('form').ajaxFormSubmit(function(data){
                popup.close();
                $('body').doneLoading();
                if(vars && vars.reload_item) {
                    $(vars.reload_item).reloadThisElement();
                } else if(vars && vars.callback) {
                    vars.callback(elm);
                }
                reload_location_if_needed();
                if (!document.closeWindow) open_new_object(view_contact_refresher, data);
            }.bind([elm,popup]), function(xhr, status, error) {
                console.log(xhr,status,error);
                $('body').doneLoading();
                squde_flash("Er ging iets mis bij het opslaan.", "alert");
            }.bind([elm,popup]), function() {
                $('body').isLoading('dark');
            });
        }
    });
    return false;
}
function view_contact_refresher(id, callback) {
    const $ = jQuery.noConflict();

    $.squdeAjaxPopup({
        url: '/courseRefresher/view/'+id,
        onOpen: function(elm, popup) {
            elm.find('form').ajaxFormSubmit(function(data){
                updateObject('contactrefreshercourse', id);
                $('body').doneLoading();
                if(callback) {
                    callback(data, elm, popup);
                }
                if (document.closeWindow) popup.close();
            }.bind([elm,popup]), function(xhr, status, error) {
                $('body').doneLoading();
                squde_flash("Er ging iets mis bij het opslaan.","alert");
            }.bind([elm,popup]), function() {
                $('body').isLoading('dark');
            });
        }
    });
    return false;
}
function delete_contact_refresher(id, name) {
    var $ = jQuery.noConflict();
    name = decodeURI(name);
    confirm("Weet u zeker dat u \""+name+"\" wilt verwijderen?", function() {
        $('body').isLoading('dark');
        $.ajax({
            url: "/courseRefresher/delete",
            data: {id:id},
            type: "POST",
            success: function(data) {
                $('[data-object-type=\'contactrefreshercourse\'][data-id=\''+id+'\'').remove();
                $('body').doneLoading();
            },
            error: function(e) {
                $('body').doneLoading();
                squde_flash("Er ging helaas iets mis.", "alert");
            }
        });
    });
    return false;
}
//jQuery(document).ready(function() {
//    var $ = jQuery.noConflict();
//    open_refresher_invitations_screen();
//    setTimeout(function() {
//        $('.invite-students-table').bind('onReload', function() {
//            $(this).find('input[type=checkbox][data-selected_students-filter]:eq(0)').prop('checked',true);
//            $(this).find('input[type=checkbox][data-selected_students-filter]:eq(1)').prop('checked',true);
//            $('select#filter_contact_moments').val(0);
//            $('form.check').submit();
//        });
//    },200);
//});
function open_refresher_invitations_screen(vars) {
    var $ = jQuery.noConflict();

    $.squdeAjaxPopup({
        url: '/courseRefresher/invitations',
        onOpen: function (elm, this_popup) {

            var contact_selector = $('select#contact_id');
            if(vars != undefined && vars.contact_id) {
                contact_selector.attr('data-current-value', vars.contact_id);
            }
            contact_selector.contactSelector();
            $('select#filter_course_id').courseSelector();

            $('select#filter_company_id').companySelector();

            //Change all open buttons for the table, so that you can add a callback function
            elm.find('table.invite-students-table').bind('onReload', function() {
                var table = $(this);
                table.find('a').updateOnClick('view_contact_refresher', function(id) {
                    view_contact_refresher(id, function(data, elm, popup) {
                        popup.close();
                        // table.reloadThisElement();
                    });
                });
            });

            elm.find('.scroll-screen:nth-child(2)').off('beforeScroll.message_selectors').on('beforeScroll.message_selectors', function() {
                initiate_default_message_selector(elm);
            });

            elm.find('form').ajaxFormSubmit(function(data, form){
                if(form.hasClass('check')) {
                    $('body').doneLoading();
                    data = JSON.parse(data);

                    const continue_to_next_screen = function() {

                        elm.find('form.write-message').find('.student-count').html(data.contracts.length);


                        ajax_popup_scroll_to_next_screen(function(screen) {
                            //Set the selected contracts
                            screen.find('input.hidden_selected_contracts').remove();
                            data.contracts.forEach(function(contract_id) {
                                screen.find('form').append('<input type="hidden" name="selected_contracts[]" class="hidden_selected_contracts" value="'+contract_id+'" />');
                            });


                            initiate_alternative_courses_toggler(elm);

                            elm.find('.invite-selected-students-table').unbind('onReload.checkAll').bind('onReload.checkAll', function() {
                                const table = elm.find('.invite-selected-students-table');
                                const checkbox = table.find('.check-whole-table');
                                if (checkbox.length > 0) {
                                    table.unbind('onReload.checkAll');
                                    checkbox[0].checked = true;
                                    checkWholeTable(checkbox[0]);
                                }
                            });

                            //Update the view_contact buttons, so that they will have a nice reload-callback
                            elm.find('.student-message-form, .supervisor-message-form').hide();
                            elm.find('.invite-selected-students-table').unbind('onReload.refresher').bind('onReload.refresher', function() {
                                const table = $(this);
                                table.find('[data-hidden-checked]').remove();

                                //Check if there are people in the list, who are not selected (supervisors)
                                //If you got no supervisors, hide the supervisor mail-stuff
                                //If you got no people from the selection, hide the student mail-stuff
                                const show_or_hide_mail_forms = function() {
                                    var student_message_form = elm.find('.student-message-form');
                                    student_message_form.hide();
                                    var supervisor_message_form = elm.find('.supervisor-message-form');
                                    supervisor_message_form.hide();

                                    table.find('tbody').find('tr[data-id]').each(function() {
                                        if (!student_message_form.is(':visible') || !supervisor_message_form.is(':visible')) {
                                            const tr = $(this);
                                            const row = tr.getThisElementsData();
                                            if (row !== null && tr.find('input[type=checkbox]').is(':checked')) {
                                                /*
                                                 If in selection, you need to have a student form
                                                 If the student is in selection AND is a supervisor, always show the student form
                                                 because he can't be his own supervisor and therefore won't receive a message
                                                 */
                                                if(row.in_selection == 1) {
                                                    student_message_form.show();
                                                }
                                                /*
                                                 If is supervisor over the current list of students, you need to have a supervisor form
                                                 */
                                                if(row.is_supervisor == 1) {
                                                    supervisor_message_form.show();
                                                }
                                            }
                                        }
                                    });
                                };
                                show_or_hide_mail_forms();
                                table.find('input[type=checkbox]').change(function() {
                                    show_or_hide_mail_forms();
                                });

                                table.find('a').updateOnClick('view_contact', function(id) {
                                    view_contact(id, function(data, elm, contact_popup) {
                                        contact_popup.close();
                                        updateObject('contact', id);
                                    });
                                });

                                // Indicate wrong and empty emails in a disclaimer
                                const wrongEmails = table.find('.email-wrong').length;
                                const emptyEmails = table.find('.email-empty').length;
                                if (wrongEmails > 0 || emptyEmails > 0) {
                                    let str = '<b>Let op:</b> Er ';
                                    str += (wrongEmails + emptyEmails) === 1 ? 'is ' : 'zijn ';
                                    if (wrongEmails > 0) {
                                        str += wrongEmails + ' foutieve email' + (wrongEmails === 1 ? '' : 's') + ' ';
                                        if (emptyEmails > 0) {
                                            str+= 'en ';
                                        }
                                    }
                                    if (emptyEmails > 0) {
                                        str += emptyEmails + ' lege email' + (emptyEmails === 1 ? '' : 's') + ' '
                                    }
                                    str += 'aanwezig in de lijst. Deze ' + ((wrongEmails + emptyEmails) === 1 ? 'persoon zal' : 'personen zullen') + ' geen bericht ontvangen';

                                    let div = table.parents('form').find('[type="submit"]').prev();
                                    if (!div.hasClass('email-warning')) {
                                        div = $('<div class="callout warning email-warning"></div>');
                                        table.parents('form').find('[type="submit"]').before(div);
                                    }
                                    div.html(str);
                                } else {
                                    table.parents('form').find('.email-warning').remove();
                                }
                            }).reloadThisElement();
                        });
                    };

                    if(data.has_multiple_contact_moments == 0) {
                        continue_to_next_screen();
                    } else {
                        confirm("Uw selectie bevat verschillende contactmomenten.<br />Weet u zeker dat u wilt doorgaan?", function() {
                            setTimeout(function() {
                                continue_to_next_screen();
                            },500);
                        });
                    }

                } else {
                    //this_popup.close();
                    if(vars !== undefined && vars.reload_item !== undefined) {
                        $('body').doneLoading();
                        $(vars.reload_item).reloadThisElement();
                    } else if(vars !== undefined && vars.callback !== undefined) {
                        $('body').doneLoading();
                        vars.callback(elm, data);
                    }
                    else {
                        // Do not reload anymore, but return to first page
                        // reload_location_if_needed();

                        setTimeout(function() {

                            console.log({elm});

                            $('body').doneLoading();
                            elm.find('.invite-students-table').find(':checked').removeAttr('checked');
                            elm.find('.invite-students-table').find('input[name="contracts\[\]"][type="hidden"]').remove();
                            elm.find('.invite-students-table').find('input[name="checked_items\[\]"][type="hidden"]').remove();
                            elm.find('.invite-students-table')[0].checked_items = [];
                            elm.find('.invite-students-table').reloadThisElement();
                            squde_reload_for_flashes();
                            ajax_popup_scroll_to_previous_screen(function() {
                                ajax_popup_scroll_to_previous_screen(function() {
                                    squde_reload_for_flashes();
                                    squde_reload_for_flashes();
                                });
                            });
                        }, 500);
                    }
                }

            }.bind([elm,this_popup]), function(xhr, status, error, form) {
                if(form.hasClass('write-message')) {
                    var response = JSON.parse(xhr.responseText);
                    var mail_errors = false;
                    for(var key in response) {
                        if(key.split('emails.').length > 1) {
                            mail_errors = true;
                        }
                    }
                    if(mail_errors) {
                        squde_flash("Niet alle geadresseerden hebben een correct e-mail adres.", "alert");
                    } else {
                        squde_flash("Er ging iets mis bij het verzenden.", "alert");
                    }
                }
                $('body').doneLoading();
                //squde_flash("Er ging iets mis bij het opslaan.", "alert");
            }.bind([elm,this_popup]), function() {
                $('body').isLoading('dark');
            });
        }
    });
    return false;
}
function initiate_alternative_courses_toggler(elm) {
    const $ = jQuery.noConflict();

    const wrapper = elm.find('.alternative-courses-wrapper');
    const alternativesToggler = wrapper.find('#offer_alternatives');
    const alternativesWrapper = wrapper.find('.alternatives-wrapper');
    const ul = alternativesWrapper.find('ul');
    const studentsTable = elm.find('.invite-students-table');
    let courses = [];

    ul.css({
        listStyle: 'none',
        margin: 0,
    });

    alternativesToggler.unbind('change').change(() => {
        const val = alternativesToggler.is(':checked:visible');
        alternativesWrapper.toggle(val);
    }).trigger('change');


    studentsTable.find('tbody tr td input[type="checkbox"]:checked').each(function() {
        const tr = $(this).parents('tr:first');
        try {
            const data = tr.getThisElementsData();
            courses.push(data.course_id);
        } catch (e) {
            console.warn('Could not get data', [e, tr.text()]);
        }
    });
    courses = _.uniq(courses);

    alternativesToggler.toggle(courses.length > 0);
    if (courses.length > 0) {
        $.get(`/courses/alternatives/${courses.join(',')}`, (data) => {
            wrapper.toggle(data.length > 0);
            alternativesToggler.trigger('change');
            data.forEach((course, index) => {
                let li = ul.find(`li:nth-child(${index + 1})`);
                if (li.length === 0) {
                    ul.find('li:first').clone().appendTo(ul);
                    li = ul.find('li:last');
                }
                li.next().hide();
                li.show();

                const label = li.find('label');
                const input = li.find('input');
                const span = li.find('span');

                const id = `alternatives_${course.id}`;
                label.attr('for', id);
                input.attr('id', id);
                input.attr('value', course.id);
                input[0].checked = true;
                span.html(course.description);
            });
        });
    }
}
function remove_contact_refresher_courses() {
    const $ = jQuery.noConflict();
    const selection = window.selected_contactRefresherCourses;
    const str = selection.length === 1 ? 'geselecteerde herhaling' : `${selection.length} geselecteerde herhalingen`;
    confirm(`Weet u zeker dat u de ${str} definitief wilt verwijderen?`, async () => {
        await $.ajax({
            method: 'delete',
            url: '/courseRefresher/massDelete',
            data: { selection },
        });

        window.reload_location_if_needed(false);
    });
    return false;
}
function generate_certificates_for_refresher(refresherCourseId) {
    const $ = jQuery.noConflict();


    $.squdeAjaxPopup({
        url: `/certificate/getCertificatesDownloadScreen/${refresherCourseId}`,
        onOpen: function (elm, popup) {
            const issuedAtInput = elm.find('#issued_at');
            if (issuedAtInput.length > 0) {
                issuedAtInput.change(function() {
                    elm.find('[type="submit"]').prop('disabled', !issuedAtInput.val());
                });
            }

            elm.find('form').submit(function() {
                elm.isLoading();
                setTimeout(() => {
                    updateObject('contactrefreshercourse', refresherCourseId);
                    popup.close();
                }, 500);
            })
        }
    });

    return false;
}
